import React, { useEffect, useRef, useState } from "react";

import supabase from "../config/supabaseCliente";
import estilo from "./styles/Reproductor.module.css";

function Reproductor() {
  const audioRef = useRef(null);

  const [nombre, setNombre] = useState(null);
  const [cancion, setCancion] = useState(null);
  const [indice, setIndice] = useState(0);
  const [play, setPlay] = useState(false);

  const [lista, setLista] = useState([]);

  useEffect(() => {
    const fetchLista = async () => {
      try {
        const { data, error } = await supabase.from("musica").select();

        if (error) {
          console.log("Error", error);
        }

        if (data) {
          setLista(data);
        }
      } catch (error) {
        console.log("Error");
      }
    };

    fetchLista();
  }, []);

  useEffect(() => {
    if (lista.length > 0) {
      setNombre(lista[0].nombre);
      setCancion(lista[0].pista);
      setPlay(false);
    }
  }, [lista]);

  const handlePlay = (nombre, pista, i) => {
    setNombre(nombre);
    setCancion(pista);
    setIndice(i);
    setPlay(true);
  };

  const handlePrevious = () => {
    const prevI = (indice - 1 + lista.length) % lista.length;
    const prevSong = lista[prevI];
    handlePlay(prevSong.nombre, prevSong.pista, prevI);
  };

  const handleNext = () => {
    const nextI = (indice + 1) % lista.length;
    const nextSong = lista[nextI];
    handlePlay(nextSong.nombre, nextSong.pista, nextI);
  };

  const handlePause = () => {
    setPlay(false);
    audioRef.current.pause();
  };

  const handleReanudar = () => {
    setPlay(true);
    audioRef.current.play();
  };

  const handleEnded = () => {
    handleNext();
  };

  const [loaded, setLoaded] = useState(0);

  useEffect(() => {
    const request = new XMLHttpRequest();
    request.open("GET", cancion, true);
    request.responseType = "blob";

    request.addEventListener("progress", handleLoadProgress);
    request.send();

    function handleLoadProgress(event) {
      if (event.lengthComputable) {
        const percentLoaded = Math.round((event.loaded / event.total) * 100);
        setLoaded(percentLoaded);
      }
    }
  }, [cancion]);

  const [menu, setMenu] = useState(false);
  const showMenu = () => setMenu(!menu);

  return (
    <div>
      {lista && (
        <div className={estilo.reproductor}>
          <div
            className={menu ? `${estilo.activo_nombre} ` : `${estilo.nombre}`}
          >
            {lista.map((e, i) => (
              <p
                key={i}
                onClick={() => handlePlay(e.nombre, e.pista, i)}
                className={nombre === e.nombre ? `${estilo.activo}` : ""}
              >
                {e.nombre}
              </p>
            ))}
          </div>

          <div className={estilo.contenido_reproductor}>
            <div className={estilo.menu}>
              <span>{nombre}</span>

              <div className={estilo.menu_icono}>
                <span>{loaded}%</span>
                <svg
                  onClick={showMenu}
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 16 16"
                >
                  <path d="M12 13c0 1.105-1.12 2-2.5 2S7 14.105 7 13s1.12-2 2.5-2 2.5.895 2.5 2z" />
                  <path d="M12 3v10h-1V3h1z" />
                  <path d="M11 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 16 2.22V4l-5 1V2.82z" />
                  <path d="M0 11.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 7H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 3H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z" />
                </svg>
              </div>
            </div>

            <div className={estilo.progress_bar}>
              <div
                className={estilo.progress}
                style={{ width: `${loaded}%` }}
              ></div>
            </div>

            <div className={estilo.play}>
              <button onClick={handlePrevious}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
                </svg>
              </button>

              {play ? (
                <button onClick={handlePause}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" />
                  </svg>
                </button>
              ) : (
                <button onClick={handleReanudar}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                  </svg>
                </button>
              )}

              <button onClick={handleNext}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                </svg>
              </button>

              <audio
                src={cancion}
                controls
                autoPlay={play}
                ref={audioRef}
                onEnded={handleEnded}
              ></audio>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Reproductor;
